import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, SubmissionError } from 'redux-form'
import { Button, Confirm } from 'semantic-ui-react'
import { StdCard } from 'components'
import { actionBGRequest, updateBGRequest, saveReturnData } from 'ducks/bankGuaranteeRequest'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { ApproveContainer, BottomActionsContainer } from './styled'
import { isNullOrEmpty, scrollToFirstValidateFailElement } from 'core/utilities'
import { bgVendorReportPath } from 'routes'

const Approve = (props) => {
  const { valueForm, handleSubmit } = props

  const [actionName, setActionName] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)

  function submitValidate(action) {
    setActionName(action)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100) // simulate server latency
      .then(() => {
        if (action.toLowerCase() === 'revise' || action.toLowerCase() === 'reject' || action.toLowerCase() === 'cancel') {
          if (!valueForm.comment) {
            throw new SubmissionError({ comment: ' Required! ' })
          }
        } else {
          var errors = {}
          if (valueForm.status === 25) {
            if (isNullOrEmpty(valueForm.appointmentReturnDate)) { errors.appointmentReturnDate = 'Require!' }
            if (isNullOrEmpty(valueForm.returnTime)) { errors.returnTime = 'Require!' }
            if (isNullOrEmpty(valueForm.returnTimeTo)) { errors.returnTimeTo = 'Require!' }

            if (!isNullOrEmpty(valueForm.returnTime) && ! isNullOrEmpty(valueForm.returnTimeTo)) {
              if (valueForm.returnTime >= valueForm.returnTimeTo) {
                errors.returnTimeTo = 'Must be more than Appointment Time!'
              }
            }

          } else if (valueForm.status === 26) {
            if (isNullOrEmpty(valueForm.returnedDate)) { errors.returnedDate = 'Require!' }
          }
          if (Object.keys(errors).length) {
            scrollToFirstValidateFailElement(errors)
            throw new SubmissionError(errors)
          }
        }

        setShowConfirm(true)
      })
  }

  function submitAction() {
    setShowConfirm(false)

    if (valueForm.status === 5 || actionName.toLowerCase() === 'resubmit') { //Status Reject 
      props.updateBGRequest(
        valueForm, 
        false, 
        props.history, 
        '', 
        () => {
          props.actionBGRequest({
            docId: valueForm.id,
            sn: valueForm.sn,
            action: actionName,
            comment: valueForm.comment,
            attachments: valueForm.BG03
          }, props.history)
        }
      )
    } else if (valueForm.status === 25 && actionName.toLowerCase() !== 'reject' && actionName.toLowerCase() !== 'revise') { // Finance Review
      props.saveReturnData(
        {
          id: valueForm.id,
          appointmentReturnDate: valueForm.appointmentReturnDate.toJSON(),
          returnTime: valueForm.returnTime.toJSON(),
          returnTimeTo: valueForm.returnTimeTo.toJSON(),
        }, 
        () => {
          props.actionBGRequest({
            docId: valueForm.id,
            sn: valueForm.sn,
            action: actionName,
            comment: valueForm.comment,
            attachments: valueForm.BG03
          }, props.history)
        }
      )
    } else if (valueForm.status === 26 && actionName.toLowerCase() !== 'reject' && actionName.toLowerCase() !== 'revise') { // Finance Process
      props.saveReturnData(
        {
          id: valueForm.id,
          returnedDate: valueForm.returnedDate.toJSON(),
          bg05: valueForm.BG05,
        },
        () => {
          props.actionBGRequest({
            docId: valueForm.id,
            sn: valueForm.sn,
            action: actionName,
            comment: valueForm.comment,
            attachments: valueForm.BG03
          }, props.history,
          () => { window.open(bgVendorReportPath, '_blank') })
        }
      )
    } else {
      props.actionBGRequest({
        docId: valueForm.id,
        sn: valueForm.sn,
        action: actionName,
        comment: valueForm.comment,
        attachments: valueForm.BG03
      }, props.history)
    }

  }

  return (
    (valueForm.sn && ((valueForm.actions || []).length > 0)) ?
      <StdCard title='Action for Approval' highlight style={{ marginTop: '1rem' }} enableCollapse={false}>
        <ApproveContainer>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Field
              name='comment'
              label='Your Comment'
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} />
            <Field name='BG03' label='Attachments' type={type.file} component={FieldInput} />
            <BottomActionsContainer>
              {
                valueForm.actions.map((actionKey) => 
                  <Button
                    type='button'
                    content={actionKey}
                    color={actionKey === 'Revise' ? 'orange' : actionKey === 'Reject' || actionKey === 'Cancel' ? 'red' : 'green'}
                    onClick={handleSubmit(() => submitValidate(actionKey))}
                  />)
              }
            </BottomActionsContainer>
          </div>
          <Confirm
            size='mini'
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => submitAction()}
          />
        </ApproveContainer>
      </StdCard> : null
  )
}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formBGRequest')(state) || {},
  })
}

const mapDispatchToProps = {
  actionBGRequest,
  updateBGRequest,
  saveReturnData
}

export default connect(mapStateToProps, mapDispatchToProps)(Approve)
